// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('support.supportcases.triggertochangelog', {
        url:'/triggertochangelog',
        views: {
            'supportView@support': {
            templateUrl: 'main/support/supportcases/triggertochangelog/triggertochangelog.tpl.html',
            controller: 'SupportCaseTriggerToChangeLogController as vm'
        }},
        resolve: {
            pricelists: pricelistsResolver,
            locations: locationsResolver
        }
    });
}

// @ngInject
function pricelistsResolver(LocationsApiService) {
    return LocationsApiService.getPricelists();
}

// @ngInject
function locationsResolver(StockApiService) {
    return StockApiService.getLocations();
}

// @ngInject
function SupportCaseTriggerToChangeLogController($state, $scope, SupportApiService, loadSpinnerService, ToasterService, $translate, pricelists, locations) {
    var vm = this;

    //Properties
    vm.testRun = true;
    vm.tabSelection = 'orders';
    vm.priceLists = pricelists;
    vm.locations = locations;
    vm.selectedLocationIds = [];
    vm.selectedPriceListId = '';
    vm.updateOrderIds = [];
    vm.updateCustomerOrderIds = [];
    vm.updateProductIds = [];
    vm.updateProductVariantIds = [];
    vm.updateStockIds = [];
    vm.updatePriceListItemIds = [];

    //Methods
    vm.saveChange = saveChange;
    vm.cancelEditing = cancelEditing;
    vm.isAllowedToSave = isAllowedToSave;
    vm.changeTab = changeTab;

    activate();

    function activate() {
    }

    function saveChange() {
        loadSpinnerService.start("mainSpinner");
        var request = {
            searchTerm: vm.searchTerm,
            testRun: vm.testRun
        };
        switch (vm.tabSelection) {
            //case 'orders': break;
            //case 'customerorders': break;
            //case 'products': break;
            //case 'productvariants': break;
            case 'stocks':
                request.locationIds = _.map(vm.selectedLocationIds, function(o) { return o.id; }); break;
            case 'pricelistitems':
                request.priceListId = vm.selectedPriceListId.id; break;
        }

        SupportApiService.triggerToChangeLog(request, vm.tabSelection).then(function(response) {
            vm.updateOrderIds = [];
            vm.updateCustomerOrderIds = [];
            vm.updateProductIds = [];
            vm.updateProductVariantIds = [];
            vm.updateStockIds = [];
            vm.updatePriceListItemIds = [];
            switch (vm.tabSelection) {
                case 'orders': vm.updateOrderIds = response.data.orderIds; break;
                case 'customerorders': vm.updateCustomerOrderIds = response.data.customerOrderIds; break;
                case 'products': vm.updateProductIds = response.data.productIds; break;
                case 'productvariants': vm.updateProductVariantIds = response.data.productVariantIds; break;
                case 'stocks': vm.updateStockIds = response.data.stockIds; break;
                case 'pricelistitems': vm.updatePriceListItemIds = response.data.priceListItemIds; break;
            }

            ToasterService.showSuccess('Triggat objekten. Se lista.', $translate.instant('support.supportCase'));
        }, function(error) {
            var message = error.message + '\n';
            _.forEach(error.errors, function(err) {
                message += err.message + '\n';
            });
            ToasterService.showError(message, $translate.instant('common.error'));
        }).finally(function() {
            loadSpinnerService.stop("mainSpinner");
        });
    }
    function cancelEditing() {
        reset();
    }
    function isAllowedToSave() {
        var hasSetSearchTerm = vm.searchTerm && vm.searchTerm.length > 0;
        var hasExtraCondition = true;
        switch (vm.tabSelection) {
            //case 'orders': break;
            //case 'customerorders': break;
            //case 'products': break;
            //case 'productvariants': break;
            default: hasExtraCondition = true; break;
            case 'stocks': hasExtraCondition = vm.selectedLocationIds.length > 0; break;
            case 'pricelistitems': hasExtraCondition = vm.selectedPriceListId && vm.selectedPriceListId.id > 0; break;
        }
        return hasSetSearchTerm && hasExtraCondition;
    }

    function changeTab(tab) {
        switch (tab) {
            case 'orders':
                vm.tabSelection = 'orders'; reset(); break;
            case 'customerorders':
                vm.tabSelection = 'customerorders'; reset(); break;
            case 'products':
                vm.tabSelection = 'products'; reset(); break;
            case 'productvariants':
                vm.tabSelection = 'productvariants'; reset(); break;
            case 'stocks':
                vm.tabSelection = 'stocks'; reset(); break;
            case 'pricelistitems':
                vm.tabSelection = 'pricelistitems'; reset(); break;
        }
    }
    function reset() {
        vm.testRun = true;
        vm.searchTerm = '';
        vm.updateOrderIds = [];
        vm.updateCustomerOrderIds = [];
        vm.updateProductIds = [];
        vm.updateProductVariantIds = [];
        vm.updateStockIds = [];
        vm.updatePriceListItemIds = [];
        vm.selectedLocationIds = [];
        vm.selectedPriceListId = '';
    }
}

angular
    .module('supportcases.triggertochangelog', ['support.api'])
    .config(stateConfig)
    .controller('SupportCaseTriggerToChangeLogController', SupportCaseTriggerToChangeLogController);
